import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';
import commonBaseService from '../../../../services/commonBaseService';

const MODULE_PREFIX = '[ OPTION CHAIN LOOK UP DATA ]';

// actions
const Actions = {
	setOptionChainLookUpData:  `${MODULE_PREFIX} setOptionChainLookUpData`,
    setForceReloadOptionChain: `${MODULE_PREFIX} setForceReloadOptionChain`,
    setLotSelection: `${MODULE_PREFIX} setLotSelection`,
    setLtpOiSelection: `${MODULE_PREFIX} setLtpOiSelection`,
    setIsExpSheetOpen: `${MODULE_PREFIX} setIsExpSheetOpen`,
};

// actions
export const setOptionChainLookUpData = createAction(
	Actions.setOptionChainLookUpData,
);

export const setForceReloadOptionChain = createAction(Actions.setForceReloadOptionChain);
export const setLtpOiSelection = createAction(Actions.setLtpOiSelection);
export const setLotSelection = createAction(Actions.setLotSelection);
export const setIsExpSheetOpen = createAction(Actions.setIsExpSheetOpen);
// selectors
export const getOptionChainLookUpData = (
	state = {},
    optionChainUniqueId = '',
) => {
	const optionChainLookupData = get(
		state,
		`optionChainLookUpData.${optionChainUniqueId}`,
		{},
	);
	return optionChainLookupData;
};

export const getSelectedOptionChainSegmentId = (state, optionChainUniqueId = '') => {
    const selectedOptionChainSegmentId = get(state, `optionChainLookUpData.${optionChainUniqueId}.selectedOptionChainSegmentId`, '');
    return selectedOptionChainSegmentId;
}

export const getSelectedOptionChainSegment = (state, optionChainUniqueId = '') => {
    const selectedOptionChainSegment = get(state, `optionChainLookUpData.${optionChainUniqueId}.selectedOptionChainSegment`, '');
    return selectedOptionChainSegment;
}

export const getSelectedOptionchainToken = (state, optionChainUniqueId = '') => {
    const selectedOptionchainToken = get(state, `optionChainLookUpData.${optionChainUniqueId}.selectedOptionChainToken`, '');
    return selectedOptionchainToken;
}

export const getSelectedOptionchainId = (state, optionChainUniqueId = '') => {
    const selectedOptionchainId = get(state, `optionChainLookUpData.${optionChainUniqueId}.selectedOptionChainId`, '');
    return selectedOptionchainId;
}

export const getSelectedOptionchainInstrument = (state, optionChainUniqueId = '') => {
    const selectedOptionchainInstrument = get(state, `optionChainLookUpData.${optionChainUniqueId}.selectedOptionChainInstrument`, '');
    return selectedOptionchainInstrument;
}

export const getLotSizeSelection = (state, optionChainUniqueId = '') => {
	const selectedLotSize = get(state, `optionChainLookUpData.${optionChainUniqueId}.ltp_per_lot`, '');
	return selectedLotSize;
 }
 
 export const getLtpOiSelection = (state, optionChainUniqueId = '') => {
	 const selectedSelection = get(state, `optionChainLookUpData.${optionChainUniqueId}.ltp_oi_selection`, '');
	 return selectedSelection;
 }


export const getExpSheetOpenState = (state, optionChainUniqueId = '') => {
    const setIsExpSheetOpen = get(state, `optionChainLookUpData.${optionChainUniqueId}.isExpSheetOpen`, false);
    return setIsExpSheetOpen;
}

export const getFinalPopularOptionChains = (state, optionChainUniqueId = '') => {
    const finalPopularOptionChains= get(state, `optionChainLookUpData.${optionChainUniqueId}.finalPopularOptionChains`, []);
    return finalPopularOptionChains;
}

export const getSelectedPopularOptionChain = (state, optionChainUniqueId = '') => {
    const selectedPopularOptionchain = get(state, `optionChainLookUpData.${optionChainUniqueId}.selectedPopularOptionChain`, false);
    return selectedPopularOptionchain;
}

export const getIsForceReloadOptionChain = (state, optionChainUniqueId = '') => {
    const isForceReload = get(state, `optionChainLookUpData.${optionChainUniqueId}.isForceReload`, false);
    return isForceReload;
}

const defaultOptionChainSelections = {
    ltp_per_lot: false,
    ltp_oi_selection: 'LTP',
    isExpSheetOpen: false,
    isForceReload: false,
}


const initialState = {};

const defaultOptionchainLookupData = {
    ...defaultOptionChainSelections,
    selectedOptionChainSegmentId:'', 
    selectedOptionChainInstrument: '',
    selectedOptionChainToken: '',
    selectedOptionChainId: '', 
    selectedOptionChainSegment: '', 
    finalPopularOptionChains: [], 
    selectedPopularOptionChain: {},
	uniqueOptionChainId: '',
    foreignKey: ''
}

// reducer
export default createReducer(initialState, (builder) => {
	builder.addCase(setOptionChainLookUpData, (state, action) => {
		const {
			selectedOptionChainSegmentId = '', 
            selectedOptionChainInstrument = '',
            selectedOptionChainToken = '',
             selectedOptionChainId = '', 
             selectedOptionChainSegment = '', 
            finalPopularOptionChains = [], 
            selectedPopularOptionChain = {},
			uniqueOptionChainId = '',
		} = action.payload;
		state[uniqueOptionChainId] = {
			selectedOptionChainSegmentId, 
            selectedOptionChainInstrument,
            selectedOptionChainToken ,
            selectedOptionChainId, 
            selectedOptionChainSegment, 
            finalPopularOptionChains, 
            selectedPopularOptionChain,
			foreignKey: `${selectedOptionChainSegment}_${selectedOptionChainToken}`,
            ...defaultOptionChainSelections,
		};
	});
    builder.addCase(setForceReloadOptionChain, (state, {payload}) => {
        const {
            uniqueOptionChainId = '', 
            isForceReload = false,
        } = payload;
        if(commonBaseService.isEmptyOrUndefined(state[uniqueOptionChainId])) {
            state[uniqueOptionChainId] = {...defaultOptionchainLookupData}
        }
        state[uniqueOptionChainId].isForceReload = isForceReload; 
    });
    builder.addCase(setIsExpSheetOpen, (state, {payload}) => {
        const {
            uniqueOptionChainId = '', 
            isExpSheetOpen= false,
        } = payload;
        if(commonBaseService.isEmptyOrUndefined(state[uniqueOptionChainId])) {
            state[uniqueOptionChainId] = {...defaultOptionchainLookupData}
        }
        state[uniqueOptionChainId].isExpSheetOpen = isExpSheetOpen; 
    });
    builder.addCase(setLotSelection, (state, {payload}) => {
        const {
            uniqueOptionChainId = '', 
            ltp_per_lot= false,
        } = payload;
        if(commonBaseService.isEmptyOrUndefined(state[uniqueOptionChainId])) {
            state[uniqueOptionChainId] = {...defaultOptionchainLookupData}
        }
        state[uniqueOptionChainId].ltp_per_lot = ltp_per_lot; 
    });
    builder.addCase(setLtpOiSelection, (state, {payload}) => {
        const {
            uniqueOptionChainId = '', 
            ltp_oi_selection= false,
        } = payload;
        if(commonBaseService.isEmptyOrUndefined(state[uniqueOptionChainId])) {
            state[uniqueOptionChainId] = {...defaultOptionchainLookupData}
        }
        state[uniqueOptionChainId].ltp_oi_selection = ltp_oi_selection; 
    });
});
